<template>
  <ModalXD>
    <div class="installation-container">
      <div class="input-wrapper">
        <h1 class="title">Legg til installasjon</h1>
      </div>
      <div class="input-wrapper">
        <div>
          <label for=""> ID: </label>
          <input type="number" placeholder="Id" v-model="installation.id" />
        </div>
        <div>
          <label> Tittel: </label>
          <input type="text" placeholder="Tittel" v-model="installation.title" />
        </div>
        <div>
          <label> Forfatter: </label>
          <input type="text" placeholder="Forfatter" v-model="installation.author" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Lese-Link: </label>
          <input type="text" placeholder="Link" v-model="installation.link" />
          <label> Lytte-Link: </label>
          <input type="text" placeholder="Link" v-model="installation.musicLink" />
        </div>
        <div>
          <label> Sted: </label>
          <input type="text" placeholder="Sted" v-model="installation.location" />
        </div>
        <div>
          <label> Koordinater: </label>
          <button @click="toggleGoogleMapsModal">Velg Koordinater</button>
          <span>Høyde: <input type="number" v-model="installation.position.lat" /></span>
          <br />
          <span>Bredde: <input type="number" v-model="installation.position.lng" /></span>
        </div>
      </div>

      <div class="input-wrapper">
        <label>Bilde:</label>
        <input type="file" ref="installationfile" class="image-selector" accept="image/*" @change="onFileChange" />
      </div>
      <div class="input-wrapper">
        <div>
          <label> Bidragsyter: </label>
          <input type="text" v-model="installation.sponsor" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Innhold: </label>

          <Editor api-key="l3hxtpsgpdlf3ypuwfuqta730sunu7tbe9u1kqc4kjgdvxds" :init="{
            height: 250,
            toolbar_mode: 'sliding',
            plugins: [
              // Core editing features
              'autolink',
              'lists',
              'searchreplace',
              'table',
              'wordcount',
            ],
            toolbar:
              'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | align lineheight | checklist numlist bullist indent outdent | removeformat',
            tinycomments_mode: 'embedded',
            tinycomments_author: 'Author name',
          }" initial-value="Welcome to TinyMCE!" v-model="installation.content" />
        </div>
      </div>
      <div class="input-wrapper">
        <button @click="publishInstallation">
          Publiser<span class="material-icons">publish</span>
        </button>
      </div>
    </div>
    <div id="g-map-wrapper" v-if="gMapOpen">
      <GoogleMap id="g-map" class="map" api-key="AIzaSyAZx4cMuWZ8ZoqddymU6G_TYpu5D0NSofg" :center="center"
        :zoom="zoomLevel" mapTypeId="satellite" @click="getCoordinates">
        <GmapCustomMarker :marker="installation.position">
          <img src="@/assets/poesi-cursor.png" alt="bilde av kart-markør" />
        </GmapCustomMarker>
      </GoogleMap>
      <p>
        Valgte koordinater er:
        <span>Høyde: {{ installation.position.lat }}, </span>
        <span>Bredde: {{ installation.position.lng }}</span>
        <button class="close-modal-button" @click="toggleGoogleMapsModal">
          Bekreft koordinater
        </button>
      </p>
    </div>
  </ModalXD>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import ModalXD from "@/components/ModalXD.vue";
import { GoogleMap } from "vue3-google-map";
import GmapCustomMarker from "vue3-gmap-custom-marker";
import { getFirestore, setDoc, doc } from "firebase/firestore";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";

export default {
  name: "ModalInstallation",
  components: {
    Editor,
    ModalXD,
    GoogleMap,
    GmapCustomMarker,
  },
  data() {
    return {
      gMapOpen: false,
      center: { lat: 59.05328, lng: 10.03517 },
      zoomLevel: 12,
      file: null,
      downloadUrl: null,
      installation: {
        id: 0,
        title: "",
        author: "",
        content: "",
        link: "",
        musicLink: "",
        img: null,
        sponsor: null,
        location: "",
        position: {
          lat: 0,
          lng: 0,
        },
        view: false,
      },
      sponsors: [
        "Sparebank1",
        "Gjensidigestiftelsen",
        "Poesiparken",
        "Larvik kommune",
        "NLI/Poesiparken/Gjensidigestiftelsen",
        "Arnes Fargehandel",
        "Kaare Mortensen AS",
        "Lundhs AS",
        "Biblioteksystemer AS",
        "Larvik Boligbyggelag",
        "Larvikbanken",
        "Reguline AS. v/ Kari Line Roald",
        "Gave fra F.G.Fritzøe Minnefond",
        "Amfi Larvik",
        "Farris Bad",
        "Grand-kvartalet",
        "DNB, Ernst-Young AS, Abax AS",
        "NOPA, Lundhs AS, Hübert AS, Nasta AS og Bjørn og Øyvind Tveter AS",
        "Larvik Havn",
        "Ingers Hage",
        "LO-senteret",
        "Handelsbanken",
        "Ecbos legater",
        "Per Fuhre Pettersen",
        "Strandberg Stein og NOPA",
        "Vestfold kollektivtrafikk",
        "Lundhs AS Larvik Havn og Heyerdahlinstituttet",
        "Larvik og omegn Turistforening",
        "Larvik By og Poesiparkens Venner",
        "http://www.klemmetsby-firing.no/",
        "Tuppen Roalds barn",
        "Fritzøe Eiendom og Larvik kommune",
        "Bergene Holm AS",
        "Poesiparkens venner",
        "Danske Bank/Poesiparken",
        "Tore Hansen/Poesiparken",
        "Håkon Ebbing/Poesiparken",
      ],
    };
  },
  methods: {
    onFileChange(event) {
      this.file = event.target.files[0];
      this.imageChanged = true;
    },
    fileName(e) {
      this.selectedFile = e.target.files[0].name;
    },
    toggleGoogleMapsModal() {
      this.gMapOpen = !this.gMapOpen;
    },
    getCoordinates(e) {
      this.installation.position.lat = e.latLng.lat();
      this.installation.position.lng = e.latLng.lng();
    },
 async publishInstallation() {
  try {
    const db = getFirestore();
    const storage = getStorage();

    // Clone installation object
    let payload = { ...this.installation };

    // 1. HÅNDTER BILDE
    if (this.imageChanged && this.file) {
      const fileName = `${Date.now()}_${this.file.name}`;
      const fileRef = storageRef(storage, `installations/${fileName}`);
      const snapshot = await uploadBytes(fileRef, this.file);
      const downloadUrl = await getDownloadURL(fileRef);

      payload.img = downloadUrl;
      console.log("snapshot:", snapshot);
      console.log("File uploaded:", downloadUrl);
    } else if (payload.img instanceof File) {
      delete payload.img;
    }

    // 2. SJEKK AT ID FINNES
    if (!payload.id && payload.id !== 0) {
      throw new Error("payload.id er påkrevd for å lage installasjon med fast ID");
    }

    // 3. BRUK payload.id SOM DOCUMENT ID
    const docId = String(payload.id);
    const docRef = doc(db, 'installations', docId);

    // 4. LAGRE MED setDoc (ikke addDoc!)
    await setDoc(docRef, {
      ...payload,
      id: docId  // behold id i dataene
    });

    console.log("New installation created with ID:", docId);

    this.$toast.success(
      payload.img ? "Installasjon opprettet med bilde!" : "Installasjon opprettet uten bilde!"
    );

    // 5. RESET
    this.installation = { title: "", description: "", img: "" };
    this.file = null;
    this.imageChanged = false;
    this.$emit("close");

  } catch (err) {
    console.error("Creation failed:", err);
    this.$toast.error("Opprettelse feilet: " + err.message);
  }
}
  },
};
</script>

<style scoped lang="scss">
.installation-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 80vh;

  .input-wrapper {
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    width: 100%;

    * {
      width: 100%;
      margin: 5px;
      margin-right: 15px;
      padding: 0;
    }

    button {
      margin: 0px;
      padding: 20px;
      font-size: 1em;
      background: #2a8355;
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      span {
        margin: 0 5px;
        width: fit-content;
      }
    }
  }
}

p {
  margin: 0;
  padding: 0;
  font-size: 1em;
}

.txt-ara {
  height: 6em;
  max-width: 100%;
  white-space: pre-wrap;
}

.custom-file-upload {
  padding: 20px;
  font-size: 1em;
  background: #2a8355;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tox {
  z-index: 100 !important;
}

#g-map-wrapper {
  position: absolute;
  height: 100vh;
  width: 80vw;
  top: 0vh;
  left: 10vw;
  margin: 0;
  padding: 0;
  background: #fff;
  z-index: 200 !important;

  #g-map {
    display: block;
    margin: 0;
    padding: 0;
    height: calc(100% - 4.5em);
    width: 100%;
  }

  p {
    margin: 0.5em;
    padding: 0.5em;
    text-align: right;
    font-size: 1em;
  }

  .close-modal-button {
    margin: 0.5em;
    padding: 0.5em;
    background-color: #2a8355;
  }
}
</style>
